import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AjaxService, UtilityService } from 'src/app/core';
import { ListConfig } from '../active-cases-list/active-cases-list.interface';
import { CommonDataService } from 'src/app/core/services/common-data.service';
@Component({
  selector: 'app-patients-common-table-grid',
  templateUrl: './patients-common-table-grid.component.html',
  styleUrls: ['./patients-common-table-grid.component.less']
})
export class PatientsCommonTableGridComponent implements OnInit {
  @Input() datalist: any[] = [];
  @Input() fieldsConfig!: ListConfig;
  @Input() tabIndex: any;
  @Output() sortChange = new EventEmitter<{ sortField: string, sortOrder: number }>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() deleteUserAction = new EventEmitter<string>();
  @Output() deletePatientAction = new EventEmitter<string>();
  @Output() deleteConsultantAction = new EventEmitter<string>();
  @Output() deleteClinicianAction = new EventEmitter<string>();
  @Output() deleteSAdminAction = new EventEmitter<string>();
  @Output() deleteAdminAction = new EventEmitter<string>();
  @Output() editUserAction = new EventEmitter<string>();
  @Output() approveUserAction = new EventEmitter<string>();
  selectedProduct: any = null;
  searchTerm: string = '';

  @ViewChild('nameTemplate', { static: true })
  private nameTemplate!: TemplateRef<any>;

  @ViewChild('ageTemplate', { static: true })
  private ageTemplate!: TemplateRef<any>;

  @ViewChild('createdDateTemplate', { static: true })
  private createdDateTemplate!: TemplateRef<any>;

  @ViewChild('modifiedDateTemplate', { static: true })
  private modifiedDateTemplate!: TemplateRef<any>;
  constructor(private _ajaxService: AjaxService,
    private _route: Router,
    private _confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _utilityService: UtilityService,
    private _translateService: TranslateService,
    private _dataService: CommonDataService) { }

  ngOnInit(): void {
  }
  onSort(event: any): void {
    console.log("Sort Clicked"+JSON.stringify(event));
    const sortField = event.field;
    const sortOrder = event.order;
    this.sortChange.emit({ sortField, sortOrder });
  }
  onSearch(): void {
    this.searchChange.emit(this.searchTerm); // Emit search term to parent
  }
  onRowSelect(event: any) {
    this.selectedProduct = event.data; // Set the selected product
  }

  onRowUnselect() {
    this.selectedProduct = null; // Clear selection
  }
  getTemplate(template: any): TemplateRef<any> {

    switch (template) {
      case 'name':
        return this.nameTemplate;
      case 'age':
        return this.ageTemplate;
      case 'createdDate':
        return this.createdDateTemplate;
      case 'modifiedDate':
        return this.modifiedDateTemplate;
      default:
        return null;
    }
  }
  getAgeFromBirthDate(date: any) {
    if (!date || date === '') {
      return null;
    }
    const dateObj = moment(date);
    const now = moment();

    const years = now.diff(dateObj, 'years');
    const months = now.diff(dateObj, 'months') % 12;

    return `${years} years and ${months} months`;
  }
  get loggedInUserRole() {
    return this._dataService?.userDetails?.data?.Role;
  }
  async onExport() {
    this._dataService.isLoading = true;
    if (this.loggedInUserRole === "clinician") {
      await this._ajaxService.post('/clinician/downloadCaseCsv', {}, { responseType: 'blob' }).subscribe(async (resp) => {
        saveAs(resp, 'data.csv');
        this._dataService.isLoading = false;
      })
    } else if ((this.loggedInUserRole === 'admin' || this.loggedInUserRole === 'superadmin') && this.tabIndex === 0) {
      await this._ajaxService.post('/consultant/downloadAllConsultantsCsv', {}, { responseType: 'blob' }).subscribe(async (resp) => {
        saveAs(resp, 'data.csv');
        this._dataService.isLoading = false;
      })
    } else if ((this.loggedInUserRole === 'admin' || this.loggedInUserRole === 'superadmin') && this.tabIndex === 1) {
      await this._ajaxService.post('/clinician/dowloadAllClinicianCsv', {}, { responseType: 'blob' }).subscribe(async (resp) => {
        saveAs(resp, 'data.csv');
        this._dataService.isLoading = false;
      })
    } else if((this.loggedInUserRole === 'admin' || this.loggedInUserRole === 'superadmin') && this.tabIndex===2){
      await this._ajaxService.post('/patient/downloadAllPatients',{},{ responseType: 'blob' }).subscribe(async(resp)=>{
        saveAs(resp, 'data.csv');
        this._dataService.isLoading=false;
      })      
    } else if((this.loggedInUserRole === 'admin' || this.loggedInUserRole === 'superadmin') && this.tabIndex===3){
      await this._ajaxService.post('/admin/downloadAllAdmins',{},{ responseType: 'blob' }).subscribe(async(resp)=>{
        saveAs(resp, 'data.csv');
        this._dataService.isLoading=false;
      })      
    }else if((this.loggedInUserRole === 'admin' || this.loggedInUserRole === 'superadmin') && this.tabIndex===4){
      await this._ajaxService.post('/super-admin/downloadAllSAdmins',{},{ responseType: 'blob' }).subscribe(async(resp)=>{
        saveAs(resp, 'data.csv');
        this._dataService.isLoading=false;
      })      
    }
  }
  editUser(data: any) {
    if(this.loggedInUserRole==="clinician"){
      const route = 'landing/update-patient/' + btoa(JSON.stringify(data))
      this._route.navigate([route]);
    }else{
      this.editUserAction.emit(data) //Admin/SuperAdmin tab index flow
    }

  }

  deleteUser(data: any) {
    if(this.tabIndex===0){
      this.deleteConsultant(data);
    }else if(this.tabIndex===1){
      this.deleteClinician(data);
    }else if(this.tabIndex===2){
      this.deletePatient(data);
    }else if(this.tabIndex===3){
      this.deleteAdmin(data);
    }else if(this.tabIndex===4){
      this.deleteSAdmin(data);
    }
  }
  deletePatient(data:any){
    this.deletePatientAction.emit(data); // Emit search term to parent
  }
  deleteConsultant(data: any) {
    this.deleteConsultantAction.emit(data); // Emit search term to parent
  }
  deleteClinician(data: any) {
    this.deleteClinicianAction.emit(data); // Emit search term to parent
  }
  deleteAdmin(data: any) {
    this.deleteAdminAction.emit(data); // Emit search term to parent
  }
  deleteSAdmin(data: any) {
    this.deleteSAdminAction.emit(data); // Emit search term to parent
  }
  approveUser(data: any) {
    this.approveUserAction.emit(data); // Emit search term to parent
  }
  isApprovedByApprover(data: any) {
    const key = 'IsApporovedByApporver' + this._dataService.approveLevel;
    return data.User[key];
  }
}
